<template>
 <section class="w-full max-w-[1270px]">
  <ModalHeader
    title="GIG Project Information"
    @onSubmit="handleSearch"
  >
   <template #filter>
    <ul class="flex flex-col flex-1 gap-3">
     <li class="inline-flex w-full gap-[26px]">
      <Input
        placeholder="프로젝트 명을 검색하세요"
        class="flex-1 bg-white [&_input]:bg-white"
        v-model="filter.name"
      >
      <template #icon>
       <img
         :src="search"
         alt="search"
         class="mr-1"
       />
      </template>
      </Input>
     </li>
    </ul>
   </template>
  </ModalHeader>
  <div class="flex items-center pt-5 pb-[18px] max-w-[1096px] mx-auto">
   <img
     :src="file"
     alt="file"
   />
   <strong class="font-semibold text-sm leading-7 -tracking-[0.2px] ml-1">전체 프로젝트</strong>
   <span class="text-violet-600 font-semibold text-sm leading-7 ml-2">{{ rows.length }}건</span>
   <Select
     class="min-w-[72px] ml-3 border border-gray-04"
     placeholder="10"
     :options="[10, 30, 50, 100]"
     v-model="perPage"
     @update:model-value="(val) => perPage = val"
   />
   <!-- <span class="ml-2 text-xs font-semibold leading-7 text-gray-04">
    ※프로젝트 상태 (임시저장 → 승인요청 → 승인/반려 → 모집마감 → 프로젝트마감요청 → 프로젝트마감승인 → 프로젝트종료)
   </span>
   <div class="flex-1"></div>
   <button
     class="inline-flex items-center gap-5 px-3 text-white bg-gray-05 rounded-7 h-7 text-[13px] leading-7 font-semibold -tracking-[0.2px] w-[156px]"
   >
    <img
      :src="download"
      alt="file"
    />
    엑셀 다운로드
   </button> -->
  </div>
  <Table
    :rows="rows"
    class="w-full max-w-[1096px] mx-auto"
    :columns="columns"
    :pagination="pagination"
    @update:page="(newPage) => page = newPage"
  >
   <template #td-action="{ row }">
    <button
      class="border border-[#888888] rounded-5 px-2 py-1 bg-white leading-4"
      @click="$emit('selected', row)"
    >Select</button>
   </template>
  </Table>
 </section>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import search from '@/assets/search.svg'
import file from '@/assets/file.svg'
import download from '@/assets/download.svg'
import Select from '@/components/ui/Select.vue'
import Input from '@/components/ui/Input.vue'
import ModalHeader from '@/components/ui/ModalHeader.vue'
import Table from '@/components/ui/Table.vue'

const filter = ref({
 name: ''
})

const columns = [
 { label: '프로젝트 명', value: 'prjct_nm' },
 { label: '고객사', value: 'ctmmny_nm' },
 { label: '시작 기간', value: 'prjct_st_ymd' },
 { label: '종료 기간', value: 'prjct_end_ymd' },
 { label: 'PM', value: 'PM_NM' },
 { label: '', value: 'action' },
]

const rows = ref([])

const store = useStore()
async function handleSearch() {
 await store.dispatch('project/fetchGIGProjects')
 const res = store.getters['project/allProjects']
 rows.value = res.filter((data) => data.prjct_nm.includes(filter.value.name))
}
handleSearch()

const perPage = ref(10)
const page = ref(1)

const pagination = computed({
 get() {
  return {
   page: page.value,
   perPage: perPage.value,
   lastPage: Math.ceil(rows.value.length / perPage.value),
  }
 },
 set(val) {
  return val
 }
});
</script>

<style lang="scss" scoped></style>